import clsx from 'clsx';

import {Avatar} from './Avatar';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  users: {
    name: string;
    src?: string;
  }[];
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
};
export function AvatarList({
  className,
  users,
  size,
  ...props
}: Props): React.JSX.Element {
  return (
    <div
      {...props}
      className={clsx(
        'flex overflow-hidden',
        size === 'xs' || size === 'sm' ? '-space-x-1' : '-space-x-2',
        className
      )}
    >
      {users.map((user) => (
        <Avatar
          key={user.name}
          name={user.name}
          src={user.src}
          size={size}
          className="ring-2 ring-slate1"
        />
      ))}
    </div>
  );
}

AvatarList.displayName = 'AvatarList';
